<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        v-if="tableStatus"
        border
        show-overflow
        resizable
        ref="costAggregation"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="150"
      >
        <!-- <template v-slot:buttons v-if="_confirmStatus == '01'">
          <el-button @click="chooseBillingRules" size="small" type="primary" class="vxe-btn-primary"
            >选择计费规则</el-button
          >
          <el-button @click="adjustmentCosts" size="small" type="primary" class="vxe-btn-delete"
            >调整费用</el-button
          >
        </template> -->
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'multiBillingRuleFlag'">{{
              row['multiBillingRuleFlag'] == 0 ? '否' : '是'
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <BillingRulesDialog
      ref="BillingRulesDialog"
      @chooseConfirmHandler="chooseConfirmHandler"
    ></BillingRulesDialog>
    <AdjustmentCostsDialog
      ref="AdjustmentCostsDialog"
      @chooseAdjustmentHandlerg="chooseAdjustmentHandlerg"
    ></AdjustmentCostsDialog>
  </div>
</template>

<script>
  import { tableColumnList } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  // import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import BillingRulesDialog from './components/BillingRulesDialog/index.vue';
  import AdjustmentCostsDialog from './components/AdjustmentCostsDialog/index.vue';
  export default {
    components: {
      BillingRulesDialog,
      AdjustmentCostsDialog,
    },
    name: 'SettleAccountsRow',
    props: {
      isCreate: {
        type: Boolean,
        require: true,
      },

      // 详情的时候获取后端数据反填上去
      linesData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableColumnList,
        currencyList: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        action: '',
        isFetchTableData: false,
        deleteLineIds: [], //删除行的ids
      };
    },
    computed: {
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      tableStatus() {
        return ['detail', 'edit'].includes(this.$route.query.status) ? this.linesData.length : true;
      },
      _confirmStatus() {
        return this.$route.query?.confirmStatus;
      },
    },
    methods: {
      // 选择计费规则
      chooseBillingRules() {
        console.log('选择计费规则');
        // linesData 拿里面的合同号
        this.$refs.BillingRulesDialog.query.contractCode = this.linesData[0].contractNo;
        this.$refs.BillingRulesDialog.openDialog();
      },
      //计费规则选择弹窗关闭
      chooseConfirmHandler(val) {
        console.log(val[0], '计费规则选择的行');
        console.log(this.getTableData()[0], 'this.getTableData()');
        let tableData = this.getTableData()[0];
        let selectData = val[0];
        let newRow = {
          ...tableData,
          originalPrice: selectData.unitPriceWithTax.toFixed(2),
          originalAmount: (selectData.unitPriceWithTax * tableData.statementQuantity).toFixed(2),
          domesticAmount: (
            selectData.unitPriceWithTax *
            tableData.statementQuantity *
            tableData.exchangeRate
          ).toFixed(2),
        };
        this._insertRow(newRow);
      },
      // 调整费用
      adjustmentCosts() {
        console.log('调整费用');
        let row = this.getTableData()[0];
        this.$refs.AdjustmentCostsDialog.query.adjustStatementQuantity = row.statementQuantity + '';
        this.$refs.AdjustmentCostsDialog.query.adjustOriginalPrice = row.originalPrice + '';
        this.$refs.AdjustmentCostsDialog.query.adjustOriginalAmount = row.originalAmount + '';
        this.$refs.AdjustmentCostsDialog.openDialog();
      },
      //调整费用弹窗关闭
      chooseAdjustmentHandlerg(val) {
        let tableData = this.getTableData()[0];
        let newRow = {
          ...tableData,
          adjustOriginalPrice: val.adjustOriginalPrice,
          adjustStatementQuantity: val.adjustStatementQuantity,
          adjustOriginalAmount: val.adjustOriginalAmount,
          adjustDomesticAmount: (val.adjustOriginalAmount * tableData.exchangeRate).toFixed(2),
          adjustReason: val.adjustReason,
        };
        this._insertRow(newRow);
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      getTableData() {
        const $table = this.$refs.costAggregation;
        return $table.getTableData().fullData;
      },

      // 反填远程返回的数据
      fullFetchTableData(val) {
        this.$nextTick(() => {
          this._insertRow(val);
        });
      },
      _insertRow(val) {
        const $table = this.$refs.costAggregation;
        console.log(val, '查看');
        $table.remove(this.getTableData()); //先删除表格所有数据
        $table?.insertAt(val, 0);
      },
    },
    mounted() {
      this.getCurrencyList();
    },
    watch: {
      linesData: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
  ::v-deep {
    .vxe-toolbar {
      display: none;
    }
  }
</style>
